// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3d9CE","errorLogs":"EditorFooter_errorLogs__1eNyS"};